// store/modules/notifications.js
import api from '@/api'

export default {
  namespaced: true,
  state: {
    unreadNotifications: 0,
    notifications: [],
    perPage: 10,
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    statusFilter: 'ALL'
  },
  getters: {
    unreadNotifications: state => {
      return state.unreadNotifications
    },
    notifications: state => {
      return state.notifications
    },
    hasMoreNotifications: state => state.currentPage < state.totalPages,
    statusFilter: state => {
      return state.statusFilter
    },
  },
  mutations: {
    SET_UNREAD_NOTIFICATIONS(state, count) {
      state.unreadNotifications = count
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications
    },
    APPEND_NOTIFICATIONS(state, notifications) {
      state.notifications = [...state.notifications, ...notifications]
    },
    SET_PAGINATION(state, { page, per_page, total_item, total_page }) {
      state.currentPage = page
      state.perPage = per_page
      state.totalItems = total_item
      state.totalPages = total_page
    },
    SET_STATUS_FILTER(state, status) {
      state.statusFilter = status
    },
    CLEAR_NOTIFICATIONS(state) {
      state.notifications = []
      state.unreadNotifications = 0
      state.perPage = 10
      state.currentPage = 1
      state.totalItems = 0
      state.totalPages = 0
      state.statusFilter = 'ALL'
    },
    DECREMENT_UNREAD_COUNT(state) {
      if (state.unreadNotifications > 0) {
        state.unreadNotifications--
      }
    },
    MARK_NOTIFICATION_AS_READ_LOCALLY(state, notificationId) {
      const index = state.notifications.findIndex(n => n.notificationId === notificationId);
      if (index !== -1) {
        state.notifications = state.notifications.map(n =>
          n.notificationId === notificationId ? { ...n, read: true } : n
        );
      }
    },
  },
  actions: {
    async fetchUnreadNotifications({ commit }) {
      try {
        const response = await api.notifications.unreadCount()
        commit('SET_UNREAD_NOTIFICATIONS', response.data.data.unread_count || 0)
      } catch (error) {
        console.error('Error fetching unread notifications:', error)
        commit('SET_UNREAD_NOTIFICATIONS', 0)
      }
    },
    async fetchNotifications({ commit, state }, {
      page = state.currentPage,
      per_page = state.perPage,
      status = state.statusFilter,
      append = false
    } = {}) {

      // Jika append=true, kita fetch halaman berikutnya
      const requestPage = append ? state.currentPage + 1 : page

      try {
        // Mengirim parameter API yang baru
        const response = await api.notifications.list({
          page: requestPage,
          per_page,
          status
        })

        // Response data notifikasi ada di response.data.data
        const notifications = (response.data.data || []).map(notification => ({
          notificationId: notification.id,
          // Mapping properti API baru:
          title: notification.title,
          message: notification.description,
          redirectType: notification.redirect_type,
          dynamicId: notification.dynamic_id,
          createdAt: notification.created_at,
          read: notification.is_read // is_read ke read
        }))

        if (requestPage === 1 || !append) {
          commit('SET_NOTIFICATIONS', notifications)
        } else {
          commit('APPEND_NOTIFICATIONS', notifications)
        }

        // Memperbarui Pagination dengan data dari meta
        commit('SET_PAGINATION', {
          page: response.data.meta.current.match(/page=(\d+)/)[1] * 1, // Ekstrak 'page' dari string 'current'
          per_page: per_page,
          total_item: response.data.meta.total_item,
          total_page: response.data.meta.total_page
        })

      } catch (error) {
        console.error('Error fetching notifications:', error)
        if (requestPage === 1 || !append) {
          commit('SET_NOTIFICATIONS', [])
        }
        // Set pagination ke nilai awal jika gagal
        commit('SET_PAGINATION', { page: 1, per_page: state.perPage, total_item: 0, total_page: 0 })
      }
    },
    async loadMoreNotifications({ dispatch, state }) {
      if (state.currentPage < state.totalPages) {
        await dispatch('fetchNotifications', {
          page: state.currentPage + 1,
          per_page: state.perPage,
          status: state.statusFilter,
          append: true
        })
      }
    },
    async setNotificationFilter({ commit, dispatch }, status) {
      commit('SET_STATUS_FILTER', status);
      // Reset dan fetch ulang untuk halaman 1
      await dispatch('fetchNotifications', { page: 1, status });
    },
    async markAsRead({ commit, state }, notificationId) {
      const notification = state.notifications.find(n => n.notificationId === notificationId);
      const wasUnread = notification ? !notification.read : false;

      try {
        // 1. Panggil API untuk menandai sudah dibaca
        await api.notifications.markAsRead(notificationId);

        // 2. Tandai di state lokal secara reaktif
        commit('MARK_NOTIFICATION_AS_READ_LOCALLY', notificationId);

        // 3. Kurangi hitungan unread hanya jika status awal adalah 'unread'
        if (wasUnread) {
          commit('DECREMENT_UNREAD_COUNT');
        }

      } catch (error) {
        console.error('Error marking notification as read:', error);
      }
    },
    async markAllAsRead({ commit }) {
      try {
        await api.notifications.markAllAsRead()
        commit('CLEAR_NOTIFICATIONS')
      } catch (error) {
        console.error('Error marking notifications as read:', error)
      }
    }
  }
}